import React from 'react'

import classNames from 'clsx'
import PropTypes from 'prop-types'

import { SvgIcon } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const path = `
M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2h5v16H6V4h2v8l2.5
-1.5L13 12V4z
`

const styles = theme => ({
  root: {
    fill: theme.palette.appSecondary.main,
  },
})

const useStyles = makeStyles(styles, { name: 'RecipeIcon' })

const RecipeIconComponent = props => {
  const { className, color, ...rest } = props
  const classes = useStyles()
  return (
    <SvgIcon
      {...rest}
      className={classNames({
        [classes.root]: !color,
        [className]: !!className,
      })}
      color={color}
    >
      <path d={path} />
    </SvgIcon>
  )
}
RecipeIconComponent.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
}
RecipeIconComponent.defaultProps = {
  className: undefined,
  color: undefined,
}
RecipeIconComponent.displayName = 'RecipeIcon'

export default React.memo(RecipeIconComponent)
